import { render, staticRenderFns } from "./entity-export-import.vue?vue&type=template&id=2a618a44&scoped=true&"
import script from "./entity-export-import.vue?vue&type=script&lang=js&"
export * from "./entity-export-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a618a44",
  null
  
)

export default component.exports